export const convertDateToUnix = (date) => {
    if (!date) return null;

    const dateObj = new Date(date);
    if (Number.isNaN(dateObj.getTime())) {
        console.error('Invalid date format:', date);
        return null;
    }

    return Math.floor(dateObj.getTime() / 1000);
};
export const convertUnixToDate = (unixTimestamp) => {
    if (!unixTimestamp) return null;

    const date = new Date(unixTimestamp * 1000);
    if (Number.isNaN(date.getTime())) {
        console.error('Invalid Unix timestamp:', unixTimestamp);
        return null;
    }

    return date.toISOString();
};

export const convertDateTimeToUnixTimestamp = (dateTime) => {
    if (!dateTime) return null;

    const dateObj = new Date(dateTime);
    if (Number.isNaN(dateObj.getTime())) {
        console.error('Invalid date-time format:', dateTime);
        return null;
    }

    return Math.floor(dateObj.getTime() / 1000);
};

export const convertUnixTimestampToDateTime = (unixTimestamp) => {
    if (!unixTimestamp) return null;

    const date = new Date(unixTimestamp * 1000);
    if (Number.isNaN(date.getTime())) {
        console.error('Invalid Unix timestamp:', unixTimestamp);
        return null;
    }

    return date.toISOString();
};
